module.exports = __webpack_public_path__ + "media/connected.803627b0.mp3";